var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Select from "react-select";
import { Controller } from "react-hook-form";
import { HDSSelectThemes, HDSSelectSingleOption, HDSSelectStyles, HDSSelectDropdownIndicator, HDSSelectClearIndicator, } from "@here/hds-react-components/Select";
import utils from "../../store/helpers/indoorHelper";
var CustomSelect = function (props) {
    var withForm = props.withForm, name = props.name, control = props.control, errors = props.errors, _a = props.placeholder, placeholder = _a === void 0 ? "Select Options" : _a, options = props.options, label = props.label, defaultValue = props.defaultValue, onSelectChange = props.onSelectChange, isDisabled = props.isDisabled, isClearable = props.isClearable, otherProps = __rest(props, ["withForm", "name", "control", "errors", "placeholder", "options", "label", "defaultValue", "onSelectChange", "isDisabled", "isClearable"]);
    if (withForm) {
        return (_jsxs("div", __assign({ className: "form-control" }, { children: [_jsx("label", __assign({ htmlFor: name, className: "select-label" }, { children: label })), _jsx(Controller, { name: name, control: control, rules: { required: true }, defaultValue: defaultValue, render: function (_a) {
                        var _b = _a.field, onChange = _b.onChange, value = _b.value, selectName = _b.name;
                        return (_jsxs("div", { children: [_jsx(Select, __assign({ name: selectName, options: options, "aria-invalid": !!errors.country, styles: utils.getFormDropdownStyle(HDSSelectStyles, !!errors[name]), "data-cy": name, theme: HDSSelectThemes, isClearable: isClearable, isDisabled: isDisabled, components: {
                                        Option: HDSSelectSingleOption,
                                        DropdownIndicator: HDSSelectDropdownIndicator,
                                        ClearIndicator: HDSSelectClearIndicator,
                                    }, defaultValue: defaultValue, menuPlacement: "auto", placeholder: placeholder, value: value, onChange: function (e) {
                                        onSelectChange === null || onSelectChange === void 0 ? void 0 : onSelectChange(e);
                                        onChange(e);
                                    } }, otherProps), name), errors[name] && (_jsx("span", __assign({ className: "error-field", role: "alert" }, { children: "".concat(label, " is required") })))] }));
                    } })] })));
    }
    return _jsx(Select, __assign({ options: options }, otherProps));
};
CustomSelect.defaultProps = {
    readOnly: false,
};
export default CustomSelect;
